var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasBanners
    ? _c("div", { staticClass: "category-banners" }, [
        _c("h2", { staticClass: "category-banners__title" }, [
          _vm._v("\n    Да, это мне подходит\n  ")
        ]),
        _c(
          "div",
          { staticClass: "category-banners__inner" },
          _vm._l(_vm.BANNERS, function(banner) {
            return _c("banner", {
              key: banner.id,
              attrs: { data: banner, "slot-name": _vm.slotName }
            })
          }),
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }